<template lang="pug" src="./hero-home.pug"></template>

<script>
import HeroSlider from './hero-home.directive'
import ModalRequestAppointment from 'components/modal/modal-request-appointment/modal-request-appointment'

export default {
  props: ['props'],
  data () {
    return {
      active: false
    }
  },
  directives: {
    HeroSlider
  },
  components: {
    ModalRequestAppointment
  }
}
</script>



// WEBPACK FOOTER //
// hero-home.vue?4e3879a0